import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useAppSelector } from "src/app/hooks";
import { selectAuth } from "src/features/authSlice";
import { runtimeConfig } from "src/services/runtimeConfig";

interface Tile {
  title: string;
  description: string;
  icon: string;
  to?: string;
  href?: string;
}

const tiles: Tile[] = [
  {
    title: "Sales Production Report",
    description: "Month-by-month production and commission detail.",
    icon: "bi-file-earmark-spreadsheet",
    href: `${runtimeConfig.coreUrl}/app/sysadmin/salesproductionreport/index`,
  },
  {
    title: "Lead Lookup",
    description:
      "Check whether a prospect is already an account before pitching.",
    icon: "bi-search",
    to: "/sales/lead-lookup",
  },
];

const SalesDashboard: React.FC = () => {
  const { hasSalesReportAccess, isAuthenticated } = useAppSelector(selectAuth);
  if (isAuthenticated && hasSalesReportAccess === false) {
    return <Navigate to="/home" replace />;
  }

  return (
    <div className="container-fluid p-3">
      <h4 className="mb-3">Sales Dashboard</h4>
      <div className="row g-3">
        {tiles.map((tile) => {
          const body = (
            <div className="card h-100 shadow-sm">
              <div className="card-body d-flex gap-3 align-items-start">
                <i
                  className={`bi ${tile.icon}`}
                  style={{ fontSize: "1.75rem", color: "#1b6ec2" }}
                />
                <div>
                  <h5 className="card-title mb-1">{tile.title}</h5>
                  <p className="card-text text-muted mb-0" style={{ fontSize: "0.875rem" }}>
                    {tile.description}
                  </p>
                </div>
              </div>
            </div>
          );

          return (
            <div key={tile.title} className="col-12 col-md-6 col-lg-4">
              {tile.to ? (
                <Link
                  to={tile.to}
                  className="text-decoration-none text-reset d-block h-100"
                >
                  {body}
                </Link>
              ) : (
                <a
                  href={tile.href}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="text-decoration-none text-reset d-block h-100"
                >
                  {body}
                </a>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SalesDashboard;
